import React from 'react';

const HQ_IMAGE = "https://customer-assets.emergentagent.com/job_23b5f19d-1a39-4e03-91cd-806fad7065f2/artifacts/e9tt8exo_08AD8CE7-9B03-4C15-B86E-5C62479D1167.png";

export const LoginScreen = ({ password, setPassword, loginError, handleLogin }) => (
  <div style={{ minHeight: '100vh', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
    <img src={HQ_IMAGE} alt="HQ" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.4 }} />
    <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: '400px', padding: '2rem' }}>
      <h1 style={{ fontFamily: "'Bangers', cursive", fontSize: '3rem', color: '#FFD700', letterSpacing: '0.04em', marginBottom: '0.5rem', textShadow: '3px 3px 0px #000' }}>
        Mission Control
      </h1>
      <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '2rem', fontWeight: 500 }}>Enter access code to proceed</p>
      <form onSubmit={handleLogin}>
        <input
          data-testid="admin-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Access Code"
          style={{
            width: '100%', padding: '1rem', fontSize: '1.5rem', textAlign: 'center',
            background: 'rgba(255,255,255,0.1)', border: '3px solid #FFD700', borderRadius: '8px',
            color: '#FFD700', fontFamily: "'Bangers', cursive", letterSpacing: '0.3em',
            outline: 'none', boxSizing: 'border-box', marginBottom: '1rem',
          }}
          autoFocus
        />
        {loginError && <p style={{ color: '#FF3B30', fontWeight: 700, marginBottom: '1rem' }}>{loginError}</p>}
        <button data-testid="admin-login-btn" type="submit" style={{
          width: '100%', padding: '1rem', background: '#FFD700', color: '#000',
          border: '3px solid #000', borderRadius: '8px', fontFamily: "'Bangers', cursive",
          fontSize: '1.25rem', letterSpacing: '0.05em', cursor: 'pointer',
          boxShadow: '4px 4px 0px 0px #000', transition: 'all 0.15s',
        }}
        onMouseEnter={(e) => { e.target.style.transform = 'translate(4px,4px)'; e.target.style.boxShadow = 'none'; }}
        onMouseLeave={(e) => { e.target.style.transform = ''; e.target.style.boxShadow = '4px 4px 0px 0px #000'; }}
        >
          Enter HQ
        </button>
      </form>
    </div>
  </div>
);
